import request from '@aned/request';

// 时效距离标准 查询 导出
export async function getStandardPage(params) {
  return request('/api/aging/rule/page', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 时效距离标准 查询 导出
export async function getStandardPageExpert(params) {
  return request('/api/aging/rule/expertData', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 时效距离标准 新增
export async function standardAdd(params) {
  return request('/api/aging/rule/create', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
// 时效距离标准 编辑
export async function standardEdit(params) {
  return request('/api/aging/rule/modify', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
// 时效距离标准 删除
export async function standardDel(params) {
  return request('/api/aging/rule/delete', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
//  时效距离标准 导入前参数校验
export async function preCreateCheck(params) {
  return request('/api/aging/rule/preCreateCheck', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
// 时效距离标准 导入
export async function standardImport(params) {
  return request('/api/aging/rule/batch', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
// 时效距离标准 同步
export async function refresh(params) {
  return request('/api/aging/distance/detail/refresh', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 时效距离明细 查询 导出
export async function getDetailedPage(params) {
  return request('/api/aging/distance/detail/page', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 时效距离明细 查询 导出
export async function getDetailedPageExpert(params) {
  return request('/api/aging/distance/detail/expertData', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 时效距离明细  编辑
export async function detailedEdit(params) {
  return request('/api/aging/distance/detail/modify', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
// 时效距离明细  计算时效
export async function actualAging(params) {
  return request('/api/aging/rule/actualAging', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 时效距离查询 查询聚合信息
export async function getPage(params) {
  return request('/api/aging/distance/aggregate/getPage', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}


// 时效距离查询 查询聚合信息
export async function getPageExpert(params) {
  return request('/api/aging/distance/aggregate/expertData', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}


